import { Link, useLocation } from 'react-router-dom';
import { useAppStore } from '../store';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { user, logout } = useAppStore();
  
  const isActive = (path: string) => location.pathname === path;
  
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/tasks" className="flex items-center gap-2">
              <img src="/ocean.svg" alt="Ocean" className="w-8 h-8" />
              <span className="font-semibold text-xl text-slate-900">Ocean</span>
            </Link>
            
            {/* Navigation */}
            <nav className="flex items-center gap-1">
              <Link
                to="/tasks"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/tasks')
                    ? 'bg-ocean-50 text-ocean-700'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
                }`}
              >
                Tasks
              </Link>
              <Link
                to="/settings"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive('/settings')
                    ? 'bg-ocean-50 text-ocean-700'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
                }`}
              >
                Settings
              </Link>
            </nav>
            
            {/* User menu */}
            <div className="flex items-center gap-4">
              <span className="text-sm text-slate-600 hidden sm:block">
                {user?.notionWorkspaceName}
              </span>
              <button
                onClick={logout}
                className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>
      
      {/* Main content */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {children}
      </main>
    </div>
  );
}


